var _path, _g, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 18,
    viewBox: "0 0 57 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_178_1763",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.05176e-05H13.6192V14.0931H0V3.05176e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_178_1763)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08269 6.41236V8.33859H11.6529C11.5129 9.41901 11.1553 10.2096 10.6113 10.7657C9.94293 11.439 8.90134 12.1749 7.08269 12.1749C4.2692 12.1749 2.06958 9.88868 2.06958 7.05451C2.06958 4.22011 4.2692 1.93411 7.08269 1.93411C8.59831 1.93411 9.70981 2.53679 10.5258 3.31195L11.8705 1.95744C10.7358 0.845617 9.21239 3.05176e-05 7.08269 3.05176e-05C3.22762 3.05176e-05 -0.0133667 3.16324 -0.0133667 7.04666C-0.0133667 10.9301 3.22762 14.0931 7.08269 14.0931C9.16564 14.0931 10.7358 13.404 11.9638 12.1202C13.2229 10.8518 13.6192 9.0588 13.6192 7.61816C13.6192 7.17181 13.5883 6.75687 13.5181 6.41236H7.08269",
    fill: "#5373AA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3319 12.1511C17.9639 12.1511 16.7825 11.016 16.7825 9.39521C16.7825 7.75876 17.9639 6.63932 19.3319 6.63932C20.6997 6.63932 21.8811 7.75876 21.8811 9.39521C21.8811 11.016 20.6997 12.1511 19.3319 12.1511ZM19.3319 4.84656C16.8371 4.84656 14.8007 6.75687 14.8007 9.39545C14.8007 12.0105 16.8371 13.9444 19.3319 13.9444C21.8268 13.9444 23.8632 12.0183 23.8632 9.39545C23.8632 6.75687 21.8268 4.84656 19.3319 4.84656V4.84656Z",
    fill: "#D84037"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2679 12.1511C37.8999 12.1511 36.8583 10.9767 36.8583 9.39521C36.8583 7.79017 37.8999 6.63932 39.2679 6.63932C40.6201 6.63932 41.6772 7.81372 41.6772 9.41091C41.685 11.0003 40.6201 12.1511 39.2679 12.1511ZM41.545 5.8644H41.4751C41.0322 5.33193 40.1772 4.84656 39.0969 4.84656C36.843 4.84656 34.8765 6.82729 34.8765 9.39545C34.8765 11.9479 36.843 13.9444 39.0969 13.9444C40.1772 13.9444 41.0322 13.459 41.4751 12.9108H41.545V13.5451C41.545 15.2832 40.6201 16.2149 39.1357 16.2149C37.9233 16.2149 37.1694 15.3381 36.8583 14.5941L35.133 15.3146C35.6304 16.5201 36.9438 18 39.1357 18C41.4595 18 43.426 16.622 43.426 13.2632V5.08139H41.545V5.8644V5.8644Z",
    fill: "#5373AA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4358 12.1511C28.0678 12.1511 26.8866 11.016 26.8866 9.39521C26.8866 7.75876 28.0678 6.63932 29.4358 6.63932C30.8038 6.63932 31.9852 7.75876 31.9852 9.39521C31.9852 11.016 30.8038 12.1511 29.4358 12.1511ZM29.4358 4.84656C26.941 4.84656 24.9045 6.75687 24.9045 9.39545C24.9045 12.0105 26.941 13.9444 29.4358 13.9444C31.9307 13.9444 33.9671 12.0183 33.9671 9.39545C33.9671 6.75687 31.9307 4.84656 29.4358 4.84656V4.84656Z",
    fill: "#F1B628"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9803 13.9442H46.9313V0.187805H44.9803V13.9442Z",
    fill: "#319F4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.815 6.55307C53.6154 6.55307 54.2994 6.96801 54.5247 7.55521L50.4443 9.25424C50.4443 7.3437 51.789 6.55307 52.815 6.55307ZM52.9548 12.1513C51.9443 12.1513 51.2294 11.6895 50.7629 10.7735L56.802 8.26008L56.6001 7.74353C56.2269 6.72569 55.0767 4.84656 52.7372 4.84656C50.4131 4.84656 48.478 6.68644 48.478 9.39545C48.478 11.9479 50.39 13.9444 52.9548 13.9444C55.0221 13.9444 56.2191 12.6681 56.7165 11.9322L55.1775 10.8987C54.6648 11.6503 53.9652 12.1513 52.9548 12.1513V12.1513Z",
    fill: "#D84037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.4e27a60663f58413139a53e596d39843.svg";
export { ForwardRef as ReactComponent };